import { Component, inject } from '@angular/core'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { getUser } from '@ziptility/store'
import { TaskStatus } from '@ziptility/graphql'
import { CommonModule } from '@angular/common'
import { TaskListItemComponent } from '@ziptility/components/task-list-item/task-list-item.component'
import { AssetProfileService } from '@ziptility/feature/asset-profile.service'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

@Component({
  selector: 'feature-tasks',
  template: `
    <div class="flex flex-col h-full shadow-inner">
      <div class="px-12 pt-4 pb-2 flex flex-row space-x-2">
        @for (status of statusOptions; track status) {
          <div
            class="p-2 px-4 text-sm rounded-full flex flex-row items-center cursor-pointer"
            [class.bg-blue-brand]="status.value == vm.selectedTaskStatus()"
            [class.text-white]="status.value == vm.selectedTaskStatus()"
            (click)="setTaskStatus(status.value)"
          >
            {{ status.key }}
          </div>
        }
      </div>
      <div class="px-12 py-2 flex-grow h-full overflow-auto">
        @if (!vm.visibleTasks().length && vm.loadingTasks()) {
          <div class="m-3">
            <mat-spinner [diameter]="20" class="gray"></mat-spinner>
          </div>
        }
        @for (task of vm.visibleTasks(); track task.id) {
          <task-list-item
            class="flex-grow cursor-pointer"
            [showBoard]="true"
            [task]="task"
            [user]="user$ | async"
            [routerLink]="['../', 'tasks', task.id]"
          ></task-list-item>
        }
      </div>
      <div class="p-5 py-4 flex flex-col border-t border-gray-200">
        <button [routerLink]="['./', 'create']" class="bv-submit-button">Add task</button>
      </div>
    </div>
  `,
  imports: [CommonModule, TaskListItemComponent, RouterModule, MatProgressSpinnerModule],
})
export class FeatureTasksComponent {
  readonly TaskStatus = TaskStatus
  readonly route = inject(ActivatedRoute)
  readonly store = inject(Store)
  readonly vm = inject(AssetProfileService)
  readonly user$ = this.store.select(getUser)

  readonly statusOptions = [
    { key: 'Open', value: TaskStatus.Open },
    { key: 'Completed', value: TaskStatus.Resolved },
  ]

  setTaskStatus(status: TaskStatus) {
    const { organizationId, featureId } = this.route.snapshot.params
    this.vm.setTaskStatus(organizationId, featureId, status)
  }
}
